// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6702":"css/admin-app.6894","6895":"css/app.6894"}[chunkId] + ".css";
};